import React, { useCallback } from 'react'
import { getContentCardByLocation } from '../../../../Utils'
import { useBraze } from '../../../../Context'
import { FullImageCard } from '../../../../Components/Callout/FullImageCard'

type DefaultCardData = {
  title?: string
  linkText?: string | unknown // Keep original definition
  imageUrl?: string
  url?: string
  location?: string
}

type CalloutProps = {
  location: string
  cardData?: DefaultCardData
}

export const HomeContentCard: React.FC<React.PropsWithChildren<CalloutProps>> = ({
  location,
  cardData,
}) => {
  const { contentCards } = useBraze()

  const renderHomeContentCard = useCallback(
    (location: string) => {
      if (!contentCards?.length) {
        //Use passed in or default home callout
        return <FullImageCard location={location} cardData={cardData} />
      }
      const card = getContentCardByLocation(contentCards, location)
      return <FullImageCard location={location} cardData={card ?? cardData} />
    },
    [contentCards, cardData]
  )

  return <>{renderHomeContentCard(location)}</>
}
